import { Injectable } from "@angular/core";
@Injectable()
export class AppInfo {
  public Version = '1.0.1';
  public PathImages = './assets/images/';
  public IsLoginActivated = true;
  public UrlLoginLocal = 'http://charly-core-securityview-dev.azurewebsites.net/login/quantumlocal';
  public UrlLoginDev = 'http://charly-core-securityview-dev.azurewebsites.net/login/quantum';
  public UrlLoginQas = 'https://charly-core-securityview-dev.azurewebsites.net/login/quantumQas';
  public UrlLoginProd = 'https://login.charlycloud.com/login/quantum';
  public UrlLoginProdAnt = 'http://charly-core-securityview-prd.azurewebsites.net/login/quantum';
}
